import { useField, useFormikContext } from "formik";
import moment from "moment";
import { useRef, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const DatePickerWithIcon = (props) => {

    const { setFieldValue,values } = useFormikContext();
    const [field] = useField(props.field);
    const {isKickoffStartDate,isKickoffEndDate} = props
    const datePickerRef = useRef(null);
    const [open, setOpen] = useState(false)
    // console.log("dddd",values.sessionStartDate[0] )

  const handleIconClick = (e) => {
    e.preventDefault()
    if (datePickerRef.current) {
        if (open){  
            datePickerRef.current.setBlur() ;
        } 
        else{
            datePickerRef.current.setFocus();
        }
        setOpen(!open)
    }
}
  
    return (
        <>
            {/* <label htmlFor="preferredDate" className="form-label">
                Session Preferred Date<sup className="required">*</sup>
            </label> */}
            <div className="position-relative datepic">
                <DatePicker
                    {...field}
                    {...props}
                    selected={(field.value && new Date(field.value)) || null}
                    onChange={(date) => {
                        if (date) {
                            // set date format as 'YYYY-MM-DD'
                            console.log(date)
                            date = moment(date).format('YYYY-MM-DD')
                            setFieldValue(field.name, date)
                        } else {
                            setFieldValue(field.name, "")
                        }
                    }}
                    // className="form-control"
                    // id="formFileDisabled"
                    placeholderText="DD-MM-YYYY"
                    dateFormat={'dd-MM-yyyy'}
                    ref={datePickerRef}
                    minDate={new Date()}                        
                    // maxDate={
                    //     isKickoffStartDate
                    //         ? values.sessionStartDate[0]
                    //             ? new Date(values.sessionStartDate[0])
                    //             : null
                    //         : isKickoffEndDate
                    //         ? values.sessionEndDate[0]
                    //             ? new Date(values.sessionEndDate[0]) // Max date is kickoffStartDate
                    //             : null
                    //         : null
                    // }
                />
                <span className="cal" onClick={handleIconClick}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={18}
                        height={20}
                        viewBox="0 0 18 20"
                        fill="none"
                    >
                        <path
                            d="M6.1875 2.5H11.8125V0.9375C11.8125 0.429688 12.2031 0 12.75 0C13.2578 0 13.6875 0.429688 13.6875 0.9375V2.5H15.25C16.6172 2.5 17.75 3.63281 17.75 5V17.5C17.75 18.9062 16.6172 20 15.25 20H2.75C1.34375 20 0.25 18.9062 0.25 17.5V5C0.25 3.63281 1.34375 2.5 2.75 2.5H4.3125V0.9375C4.3125 0.429688 4.70312 0 5.25 0C5.75781 0 6.1875 0.429688 6.1875 0.9375V2.5ZM2.125 17.5C2.125 17.8516 2.39844 18.125 2.75 18.125H15.25C15.5625 18.125 15.875 17.8516 15.875 17.5V7.5H2.125V17.5Z"
                            fill="#2D2D2D"
                        />
                    </svg>
                </span>
            </div>
        </>
    )
}

export default DatePickerWithIcon